import { Link } from "react-router-dom";
import ContentCard from "@/components/base/ContentCard";
import { SectionHeading } from "@/components/base/PageIntro";
import usePageMeta from "@/hooks/usePageMeta";
import { movieItems, newsItems, varietyItems } from "@/mocks/content";
import type { AnyContent } from "@/lib/content";
import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import HotRanking from "./components/HotRanking";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  usePageMeta(
    "红桃网 - 全方位娱乐资讯与互动平台",
    "红桃网为您提供最新的娱乐资讯、影视推荐、热点新闻和丰富的娱乐互动内容，覆盖电影、电视剧、综艺等多个领域，让用户轻松获取娱乐信息和分享乐趣。",
    "红桃网,娱乐资讯,影视推荐,电影新闻,电视剧动态,综艺节目,互动娱乐平台,娱乐热点",
  );

  const allContent: AnyContent[] = [...newsItems, ...movieItems, ...varietyItems];

  const latest = [...allContent]
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, 12);

  const hot = [...allContent].sort((a, b) => b.views - a.views).slice(0, 10);

  return (
    <div className="mx-auto w-full max-w-portal px-4 py-5 md:px-6 md:py-7">
      <h1 className="sr-only">红桃网 - 全方位娱乐资讯与互动平台</h1>
      <HeroCarousel />

      <div className="mt-4">
        <CategoryShortcuts />
      </div>

      <div className="mt-9 grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_320px] lg:gap-9">
        <section>
          <SectionHeading
            title="最新发布"
            subtitle="资讯、片单与节目动态，按发布时间汇总"
            actionLabel="查看全部资讯"
            actionTo="/news"
          />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {latest.map((item) => (
              <ContentCard key={`${item.type}-${item.id}`} item={item} />
            ))}
          </div>
        </section>

        <aside className="self-start">
          <HotRanking items={hot} />

          <div className="mt-4 overflow-hidden rounded-lg bg-primary-950 p-5 text-background-100">
            <p className="flex items-center gap-2 font-label text-[11px] tracking-[0.24em] text-accent-400">
              <i className="ri-quill-pen-line" />
              编辑手记
            </p>
            <h3 className="mt-2 font-heading text-base font-bold text-background-50">本周想说的话</h3>
            <p className="mt-2 text-sm leading-relaxed text-primary-100/80">
              “今年最好看的几部作品，都不急着把情绪推到你面前。它们愿意等，等观众自己走过去。”
            </p>
            <Link
              to="/recommendations"
              className="mt-4 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-xs text-foreground-950 transition-colors hover:bg-accent-400"
            >
              看本周片单
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="mt-4 rounded-lg border border-background-200 bg-background-50 p-4">
            <h3 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
              <i className="ri-notification-3-line text-primary-500" />
              本周看点
            </h3>
            <ul className="mt-3 space-y-2.5 text-xs leading-relaxed text-foreground-600">
              <li className="flex gap-2">
                <span className="mt-1 h-1 w-1 shrink-0 rounded-full bg-primary-400" />
                《雾港》更新至第 6 集，本周迎来关键转折。
              </li>
              <li className="flex gap-2">
                <span className="mt-1 h-1 w-1 shrink-0 rounded-full bg-primary-400" />
                《一起出发吧》收官站，六人重回出发地。
              </li>
              <li className="flex gap-2">
                <span className="mt-1 h-1 w-1 shrink-0 rounded-full bg-primary-400" />
                城市电影节展映单元持续至本月底。
              </li>
            </ul>
          </div>
        </aside>
      </div>

      <div className="mt-10">
        <SiteIntro />
      </div>
    </div>
  );
}